/**
 * Product image hotspots: hover/click to show popover, prevent zoom/lightbox conflict.
 * - Hover on hotspot pin: show popover (dialog with product image, price, title).
 * - Mouse leave (pin + popover): hide after short delay so user can move to popover.
 * - Click on hotspot: stopPropagation + preventDefault so Fancybox doesn't open; toggle for touch.
 */
(function () {
  var hoverDelay = 120;

  function initHotspots(section) {
    if (!section || !section.querySelector('.product-hotspots')) return;
    var hotspots = section.querySelectorAll('.product-hotspot');
    hotspots.forEach(function (wrapper) {
      var btn = wrapper.querySelector('[data-hotspot-trigger]');
      var popover = wrapper.querySelector('[data-hotspot-popover]');
      if (!btn || !popover) return;

      var hideTimer = null;
      function scheduleHide() {
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
          hideTimer = null;
          btn.setAttribute('aria-expanded', 'false');
          popover.setAttribute('aria-hidden', 'true');
          popover.classList.remove('is-visible');
        }, hoverDelay);
      }
      function cancelHide() {
        if (hideTimer) {
          clearTimeout(hideTimer);
          hideTimer = null;
        }
      }
      function show() {
        cancelHide();
        closeAllInSection(section);
        btn.setAttribute('aria-expanded', 'true');
        popover.setAttribute('aria-hidden', 'false');
        popover.classList.add('is-visible');
      }
      function hide() {
        scheduleHide();
      }

      wrapper.addEventListener('mouseenter', function () {
        show();
      });
      wrapper.addEventListener('mouseleave', function () {
        hide();
      });

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        closeAllInSection(section);
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          popover.setAttribute('aria-hidden', 'false');
          popover.classList.add('is-visible');
        }
      });
    });

    section.querySelectorAll('[data-hotspot-link]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    document.addEventListener('click', function outsideClick(e) {
      if (section.contains(e.target)) return;
      closeAllInSection(section);
    });
  }

  function closeAllInSection(section) {
    if (!section) return;
    section.querySelectorAll('[data-hotspot-trigger][aria-expanded="true"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      var popover = btn.nextElementSibling;
      if (popover && popover.matches('[data-hotspot-popover]')) {
        popover.setAttribute('aria-hidden', 'true');
        popover.classList.remove('is-visible');
      }
    });
  }

  function run() {
    document.querySelectorAll('.product-hotspots').forEach(function (block) {
      var section = block.closest('[data-section-type="product"]');
      if (section) initHotspots(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.detail && e.detail.container;
    if (section && section.querySelector('.product-hotspots')) initHotspots(section);
  });
})();
